import { Injectable } from '@angular/core';
import { LocalStorageService } from '@vendasta/uikit';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, skip } from 'rxjs/operators';

const KEY_PREFIX = 'ONETIME-';
const ENABLED = 'enabled';
const SHOWN = 'shown';

@Injectable({ providedIn: 'root' })
export class OneTimeService {
  public static readonly HELP_POPOVER = 'help';

  private triggers: Map<string, BehaviorSubject<number>> = new Map();

  constructor(private localStorageService: LocalStorageService) {}

  enable(id: string): void {
    const state = this.localStorageService.get(KEY_PREFIX + id);
    if (!state) {
      this.localStorageService.set(KEY_PREFIX + id, ENABLED);
    }
  }

  show$(id: string): Observable<boolean> {
    const trigger = this.getTrigger(id);
    return trigger.asObservable().pipe(
      skip(1), // Ignore the initial state by skipping the first one.
      map(() => {
        const show = this.localStorageService.get(KEY_PREFIX + id) === ENABLED;
        return show;
      }),
    );
  }

  showInitialState$(id: string): Observable<boolean> {
    const trigger = this.getTrigger(id);
    return trigger.asObservable().pipe(
      map(() => {
        const show = this.localStorageService.get(KEY_PREFIX + id) === ENABLED;
        return show;
      }),
    );
  }

  private getTrigger(id: string): BehaviorSubject<number> {
    let trigger = this.triggers.get(id);
    if (!trigger) {
      this.triggers.set(id, new BehaviorSubject<number>(0));
      trigger = this.triggers.get(id);
    }
    return trigger;
  }

  markAsShown(id: string): void {
    this.localStorageService.set(KEY_PREFIX + id, SHOWN);
    this.trigger(id);
  }

  trigger(id: string): void {
    const trigger = this.getTrigger(id);
    trigger.next(trigger.getValue() + 1);
  }
}
